import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

export default class extends BridgeComponent {
  static component = 'health-kit';

  connect() {
    this.send('request-authorization');
  }
}
